export const TRANSFEROR = 'TRANSFEROR';
export const TRANSFEREE = 'TRANSFEREE';

// 계약서 상태
export const CONTRACT_STATUS_BEFORE = 'BEFORE';
export const CONTRACT_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const CONTRACT_STATUS_COMPLETED = 'COMPLETED';
